// 1. Crear el componente CompetitionCoverImage.js
// src/components/common/CompetitionCoverImage.js

import React from 'react';
import { EmojiEvents as TrophyIcon } from '@mui/icons-material';
import { Box, Typography } from '@mui/material';

const CompetitionCoverImage = ({ 
  src, 
  alt, 
  width = '100%', 
  height = 180, 
  competitionName = 'Competencia',
  borderRadius = '0px',
  showPlaceholder = true,
  sx = {} 
}) => {
  
  // Componente de imagen placeholder personalizada
  const DefaultCoverImage = () => (
    <Box
      sx={{
        width: '100%',
        height: '100%',
        background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        color: 'white',
        position: 'relative',
        overflow: 'hidden',
      }}
    >
      {/* Patrón de fondo decorativo */}
      <Box
        sx={{
          position: 'absolute',
          top: 0,
          left: 0,
          right: 0,
          bottom: 0,
          backgroundImage: `
            radial-gradient(circle at 25% 25%, rgba(255,255,255,0.1) 0%, transparent 50%),
            radial-gradient(circle at 75% 75%, rgba(255,255,255,0.1) 0%, transparent 50%)
          `,
        }}
      />
      
      {/* Contenido */}
      <TrophyIcon sx={{ fontSize: 48, mb: 1, opacity: 0.9 }} />
      <Typography 
        variant="h6" 
        sx={{ 
          fontWeight: 'bold', 
          textAlign: 'center',
          px: 2,
          textShadow: '0 2px 4px rgba(0,0,0,0.3)',
          fontSize: { xs: '0.9rem', sm: '1.1rem' },
          lineHeight: 1.2
        }}
      >
        {competitionName}
      </Typography>
      <Typography 
        variant="caption" 
        sx={{ 
          opacity: 0.8,
          textAlign: 'center',
          mt: 0.5,
          textShadow: '0 1px 2px rgba(0,0,0,0.3)'
        }}
      >
        Imagen de portada
      </Typography>
    </Box>
  );

  return (
    <Box
      sx={{
        width: width,
        height: height,
        borderRadius: borderRadius,
        overflow: 'hidden',
        position: 'relative',
        backgroundColor: '#f5f5f5',
        ...sx
      }}
    >
      {src ? (
        <Box
          component="img"
          src={src}
          alt={alt}
          sx={{
            width: '100%',
            height: '100%',
            objectFit: 'cover',
            display: 'block',
          }}
          onError={(e) => {
            // Si la imagen falla al cargar, mostrar placeholder
            if (showPlaceholder) {
              e.target.style.display = 'none';
              e.target.nextSibling.style.display = 'flex';
            }
          }}
        />
      ) : null}
      
      {/* Mostrar placeholder si no hay src */}
      <Box
        sx={{
          position: src ? 'absolute' : 'static',
          top: 0,
          left: 0,
          width: '100%',
          height: '100%',
          display: src ? 'none' : 'flex',
        }}
      >
        {showPlaceholder && <DefaultCoverImage />}
      </Box>
    </Box>
  );
};

export default CompetitionCoverImage;